import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { legacyTheme, styled } from '@prose-ui/legacy';

import { ProgressTracker } from 'Components/ProgressTracker';
import { breakpoints } from 'Components/ThemeProvider';
import { Typography } from 'Components/Typography';
import { ConsultationFooter } from '../Components/ConsultationFooter';

import * as consultationCategories from '../constants/consultationProductsCategories';

import consultationCategoryProp from 'PropTypes/consultationProps';
import consultationSubsetCategoryProp from 'PropTypes/consultationSubsetProps';
import HairTexureProps from 'PropTypes/HairTextureProps';

import { LegacyBaseScene as BaseScene } from 'Scenes/LegacyBaseScene';

import useMedia from 'utils/useMedia';

import * as consultationSelectors from 'dux/consultation/selectors';

const Image = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  background-position: center;
  background-size: cover;
`;

const Text = styled.div`
  position: relative;
`;

const Subtitle = styled(Typography)`
  max-width: 296px;

  ${legacyTheme.breakpoints.up('sm')} {
    max-width: 340px;
  }
`;

export const Transition = ({
  body,
  buttonLabel,
  consultationCategory,
  consultationSubsetCategory,
  hairTexture,
  image,
  questionIndex,
  onNext,
  routeParams,
  title,
  subtitle,
}) => {
  const isDesktop = useMedia(`(min-width: ${breakpoints.md}px)`);
  const istablet = useMedia(`(min-width: ${breakpoints.sm}px)`);
  const imageSet = image({ hairTexture });
  const imageSrc = isDesktop ? imageSet.desktop : istablet ? imageSet.tablet : imageSet.mobile;

  let content;
  if (consultationCategory === consultationCategories.HAIRCARE) {
    content = (
      <Text>
        <Typography align="center" bold color="white" paragraph variant="mono2">
          {title}
        </Typography>
        <Typography align="center" color="white" paragraph variant="h1r">
          {subtitle}
        </Typography>
        <Subtitle align="center" color="white" paragraph variant="p1">
          {body}
        </Subtitle>
      </Text>
    );
  } else {
    content = (
      <Text>
        <Typography align="center" bold color="white" paragraph variant="mono2">
          {title}
        </Typography>
        <Typography align="center" color="white" paragraph variant="h1r">
          {subtitle}
        </Typography>
        <Subtitle align="center" color="white" paragraph variant="p1">
          {body}
        </Subtitle>
      </Text>
    );
  }

  return (
    <BaseScene background="beige" header relativePosition>
      <ProgressTracker
        consultationCategory={consultationCategory}
        consultationSubsetCategory={consultationSubsetCategory}
        questionIndex={questionIndex}
        routeParams={routeParams}
      />

      <Image
        style={{
          backgroundImage: `url(${imageSrc.src})`,
        }}
      />
      {content}
      <ConsultationFooter
        buttonLabel={buttonLabel}
        disabled={false}
        isSaving={false}
        submit={onNext}
      />
    </BaseScene>
  );
};

Transition.propTypes = {
  body: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  consultationCategory: consultationCategoryProp.isRequired,
  consultationSubsetCategory: consultationSubsetCategoryProp,
  hairTexture: HairTexureProps,
  image: PropTypes.func.isRequired,
  questionIndex: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  routeParams: PropTypes.shape({}),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

Transition.defaultProps = {
  buttonLabel: 'Next',
  consultationSubsetCategory: null,
  subtitle: null,
  hairTexture: null,
  routeParams: null,
};

export default connect(
  (state, { consultationCategory, consultationSubsetCategory, questionIndex, routeParams }) => ({
    ...consultationSelectors.getConsultationQuestionForIndex(state, {
      consultationCategory,
      consultationSubsetCategory,
      questionIndex,
      routeParams,
    }),
    hairTexture: consultationSelectors.getHairTexture(state),
  })
)(Transition);
